import {
  PreviewApps,
  PreviewBusiness,
  PreviewCoupon,
  PreviewEvent,
  PreviewFeedback,
  PreviewImages,
  PreviewLinks,
  PreviewPdf,
  PreviewSocial,
  PreviewUrl,
  PreviewVideo,
  PreviewWebsite,
  PreviewWifi,
  PreviewYoutube,
  PreviewMp3,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "@/components/previews";

import { VcardTemplate } from "@/features/previews/templates/vcard";

import { previewRegistry } from "./PreviewRegistry";
import { QRProps } from "../types";

let initialized = false;

// Registers every legacy preview component under the same keys as `data.type`.
export const initializePreviewRegistry = (): void => {
  if (initialized) {
    return;
  }
  initialized = true;

  previewRegistry.registerLegacy("website", PreviewWebsite);
  previewRegistry.registerLegacy("listoflinks", PreviewLinks);
  previewRegistry.registerLegacy("pdf", PreviewPdf);
  previewRegistry.registerLegacy("url", PreviewUrl);
  previewRegistry.registerLegacy("apps", PreviewApps);
  previewRegistry.registerLegacy("business", PreviewBusiness);
  previewRegistry.registerLegacy("image", PreviewImages);
  previewRegistry.registerLegacy("video", PreviewVideo);
  previewRegistry.registerLegacy("wifi", PreviewWifi);
  previewRegistry.registerLegacy("youtube", PreviewYoutube);
  previewRegistry.registerLegacy("social", PreviewSocial);
  previewRegistry.registerLegacy("event", PreviewEvent);
  previewRegistry.registerLegacy("coupon", PreviewCoupon);
  previewRegistry.registerLegacy("feedback", PreviewFeedback);
  previewRegistry.registerLegacy("mp3", PreviewMp3);
  previewRegistry.registerLegacy("text", PreviewText);
  previewRegistry.registerLegacy("email", PreviewEmail);
  previewRegistry.registerLegacy("url-static", PreviewUrlStatic);
  previewRegistry.registerLegacy("sms", PreviewSMS);
  previewRegistry.registerLegacy("whatsapp", PreviewWhatsapp);

  previewRegistry.register(
    "vcard",
    VcardTemplate,
    () =>
      import("@/features/previews/templates/vcard/initPreviewVcardData.json") as unknown as Promise<
        QRProps<"vcard">
      >
  );
};
